import React from 'react';
import Icon from '../icon/Icon';
import './panel.scss';

export default function Panel(props) {
  const status = (function () {
    switch (props.status) {
      case 'loading':
        return <Icon className="panel--loading" icon="loading" style={{ color: '#409EFF' }} />;
      case 'success':
        return <Icon className="panel--success" icon="dui1-copy-copy" style={{ color: '#409EFF' }} />;
      case 'fail':
        return <Icon className="panel--fail" icon="cuo" style={{ color: '#FF0000' }} />;
      case 'default':
      default:
        return <span>{props.defaultText}</span>;
    }
  }());

  return (
    <div className="panel" onClick={props.onClick}>
      <div className="panel-content">
        <div className="panel-title">
          {props.title}
        </div>
        <div className="panel-status">
          {status}
        </div>
      </div>
    </div>
  );
}
